(ns frontend.events
  (:require
   [re-frame.core :as rf]
   [common.time :as time]
   [frontend.routing :as routing]
   [ui.state.session.model :as session-model]
   ;; Required for its side effect: registering the handler for the pushed
   ;; completion event, so a completion that arrives before any waiter is
   ;; registered still reaches the log rather than falling through
   ;; comms.sente's "unhandled" path.
   [ui.completion.event]
   [ui.sync.event]
   [common.schema.entity-types :as entity-types]
   [frontend.sub.view :as view-sub]))

(rf/reg-event-db
 ::init-app-db
 (fn [db [_]]
   (let [db {:initialized? true
             :app-startup  (time/now-millis)}]
     db)))



(rf/reg-event-fx
 ::navigate
 (fn [{:keys [db]}
      [_
       {:keys [path-args view-params]
        :as   args}]]
   {::routing/old-routing {:path-args   path-args
                           :view-params (or view-params {})}}))


;; Todo - should generic re-frame events - that should be always available - be stored here?

; temporary function to represent future entity syncing in frontend
; cannot use namespaced key, causes circular dependency
(rf/reg-event-db
 :manage-entities
 (fn [db [_ entities]]
   (let [entities-to-store (->> entities
                                (vals)
                                (filter (fn [entity]
                                          (-> entity
                                              :entity/type
                                              (entity-types/is-entity-synced?))))
                                (map (fn [entity]
                                       [(:db/id entity) entity]))
                                (into {}))
         existing-entities (:entities db)
         new-entities (merge existing-entities entities-to-store)]
     (-> db
         (assoc :entities new-entities)))))

(rf/reg-event-db
 :add-and-remove-entities
 [rf/trim-v]
 (fn [db [{:keys [entities-to-add entity-ids-to-remove]}]]
   (let [entities-to-store
         (->> entities-to-add
              (vals)
              (filter (fn [entity]
                        (-> entity
                            :entity/type
                            (entity-types/is-entity-synced?))))
              (map (fn [entity]
                     [(:db/id entity) entity]))
              (into {}))]
     (-> db
         (session-model/merge-entities entities-to-store)
         (session-model/remove-entities entity-ids-to-remove)))))
